module.exports = __webpack_public_path__ + "img/menu.abe09fb8.svg";